import { gsap, ScrollTrigger } from "./globals.js";
// Function to animate the .char elements
export function animateChars(className) {
    const elements = document.querySelectorAll(`${className}`); // Select all elements with the given class
    const tl = gsap.timeline({
        defaults: {
            ease: "power2.inOut"
        }
    });

    elements.forEach(element => {
        const chars = element.querySelectorAll(".char");

        tl.fromTo(chars, {
            willChange: "opacity",
            opacity: 1e-4
        }, {
            opacity: 1,
            stagger: 1.2 / chars.length, // Calculate stagger delay based on number of characters
            duration: 1.2
        });
    });

    return tl; // Return the timeline to be used elsewhere
}
